<template>
  <div>
    <result-pay :url="url" business-type="kk"/>
  </div>
</template>

<script>
import ResultPay from './../page/result-pay';
import Api from './api';
export default {
  name: 'ResultPayVue',
  components: {
    ResultPay
  },
  data () {
    return {
      url: Api.KKPREFIX
    };
  },
  mounted () {},
  created () {},
  methods: {}
};
</script>
